export default {
  loading: "Loading...",

  delivery: "Delivery",
  order: "Order",

  delivery_success: "Delivery Successful",
  delivery_completed_msg: "Thank you! Delivery has been completed.",

  invalid_link_title: "❌ Invalid Link",
  invalid_link_msg: "This delivery link is not valid.",

  delivery_completed_title: "✅ Delivery Completed",
  delivery_completed_msg_short: "This delivery link is no longer active.",

  link_expired_title: "⌛ Link Expired",
  contact_restaurant: "Please contact restaurant.",

  navigate_location: "Navigate to Location",
  gps_enabled: "📍 GPS Navigation Enabled",
  start_navigation: "Start Navigation",

  restaurant: "Restaurant",
  call: "Call",

  order_items: "Order Items",

  payment: "Payment",
  status: "Status",
  mark_payment_received: "Mark Payment Received",

  complete_delivery: "Complete Delivery",
  enter_otp: "Enter OTP",
  mark_delivered: "Mark Delivered",
};